import React from 'react';
import ProductAdvertising from '../../../components/ProductAdvertising';
import { useIntl } from 'react-intl';

const Billboards = () => {

    const textTranslator = useIntl();

    const data = {
        id: 24,
        id_en: 345,
        context: 'billboards',
        title: textTranslator.formatMessage({ id: 'products.blocs.takeover' })
    }
    return (
        <div>
            <ProductAdvertising data={data} />
        </div>
    );
};

export default Billboards;